import { render, staticRenderFns } from "./insDocsDownload.vue?vue&type=template&id=48413134&"
import script from "./insDocsDownload.vue?vue&type=script&lang=js&"
export * from "./insDocsDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports